import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

// Default fallback shown while a route's loader is running (e.g. first
// navigation into a route whose data isn't cached yet). Wired up via the
// router's `defaultPendingComponent`; routes can override per-route.
export function RoutePending(): ReactElement {
    const { t } = useTranslation();
    return (
        <Box
            component="output"
            aria-label={t('ACTIONS.LOADING')}
            sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 6 }}>
            <CircularProgress />
        </Box>
    );
}
